import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-arrow-small",
  "use": "app-icon-arrow-small-usage",
  "viewBox": "0 0 122 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 122 9\" id=\"app-icon-arrow-small\"><path d=\"M112.5 5H.5V4h112V0l9 4.5-9 4.5z\" fill=\"#B8BECC\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol